


























































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Button, Checkbox, Form, FormItem, Input } from 'element-ui';
import Avatar from '@/components/Avatar.vue';
import ModalCard from '@/components/layout/ModalCard.vue';

import { signedUploadService } from '@/services/SignedUploadService';

import rules from '@/rules/rules';

import get from 'lodash/get';

// gql
import UpdateOperatorMutation from '@/graphql/mutations/operator/Update.gql';

// mixins
import scrollError from '@/mixins/scrollError';

// types
import { OperatorFields, OperatorInput } from '@/types/graphql/schemaTypes';

interface HTMLInputEvent extends Event {
  target: HTMLInputElement & EventTarget;
}

@Component({
  components: {
    Avatar,
    ModalCard,
    'el-button': Button,
    'el-checkbox': Checkbox,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  }
})
export default class UserEdit extends Mixins(scrollError) {
  @Prop({ type: Object }) user!: OperatorFields;
  @Prop({ default: false, type: Boolean }) open!: boolean;

  file = null;
  formInput: OperatorInput = {};
  isLoading = false;

  readonly rules = rules;

  $refs!: {
    userForm: HTMLFormElement;
    fileInput: HTMLInputElement;
  };

  get avatar() {
    return this.user?.avatar?.url;
  }

  closeModal() {
    this.$emit('closed');
  }

  submit() {
    this.$refs.userForm.validate(async(valid: boolean) => {
      if (!valid) {
        this.scrollError(this.$refs.userForm);
        return;
      }

      this.isLoading = true;

      try {
        const response = await this.$apollo.mutate({
          mutation: UpdateOperatorMutation,
          variables: {
            operatorArgs: this.formInput
          }
        });

        if (response) {
          // update stored profile to update accross the app
          this.$store.dispatch('User/userInit');
          this.$store.dispatch('Alert/addAlert', {
            type: 'success',
            message: this.$t('success.updated'),
            time: 2000
          });
          this.$emit('close');
        }
      } catch {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.push'),
          time: 2000
        });
      } finally {
        this.isLoading = false;
      }
    });
  }

  openFile() {
    this.$refs.fileInput.click();
  }

  addFile(e: HTMLInputEvent) {
    const file = get(e, 'target.files[0]');
    this.file = URL.createObjectURL(file);
    signedUploadService
      .startClientUpload(file)
      .then(resFields => {
        // inject new avatar
        this.formInput.avatar = {
          key: resFields.key
        };
      })
      .catch((error) => {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: error.message,
          time: 2000
        });
      });
  }

  @Watch('user', { immediate: true })
  private setUser(user: OperatorFields) {
    this.formInput = {
      email: user.email,
      emailNotifications: user.emailNotifications,
      firstName: user.firstName,
      lastName: user.lastName,
      phoneNumber: user.phoneNumber
    };
  }
}
